/* Component in PostPage to display the Post data */
import React, { useEffect, useState } from "react";

import Card from "react-bootstrap/Card";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import {Image} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { Link, useHistory } from "react-router-dom";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useCurrentUser } from "../../contexts/CurrentUserContext";
import Avatar from "../../components/Avatar";
import { axiosInstance, axiosRes } from "../../api/axiosDefaults";
import { PostDropdown } from "../../components/PostDropdown";
import {
  useSetCategoryContext,
  useSetDeptContext,
  useSetNumberContext,
  useSetSceneContext,
} from "../../contexts/DeptCategoryContext";
// import appStyles from "../../../src/styles/App.module.css";
import useHostName from "../../hooks/useHostName";
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config";
// import appStyles from "../../styles/App.module.css";
import styles from "../../styles/Post.module.css";
import btnStyles from "../../styles/Button.module.css";
import TopBox from "../../components/TopBox";
import toast from "react-hot-toast";
import { useSetImageContext } from '../../contexts/ImageContext';

const Post = (props) => {
  const {
    id,
    owner,
    name,
    position,
    profile_id,
    profile_image,
    comments_count,
    likes_count,
    like_id,
    archive_id,
    title,
    content,
    scene,
    number,
    departments,
    category,
    image1,
    image2,
    image3,
    image4,
    image5,
    updated_at,
    setPosts,
    episode_number,
  } = props;

  const host = useHostName();
  const currentUser = useCurrentUser();
  const is_owner = currentUser?.username === owner;
  const setImage = useSetImageContext();
  const history = useHistory();
  const setSceneId = useSetSceneContext();
  const setDept = useSetDeptContext();
  const setCategory = useSetCategoryContext();
  const setNumber = useSetNumberContext();
  const [showActionMenu, setShowActionMenu] = useState(true);
  const queryString = window.location.search;

  // Use URLSearchParams to parse the query string
  const params = new URLSearchParams(queryString);
  const epi = params.get("episode");
  const project = params.get("project");
  const episodeTitle = params.get("episodeTitle");

  // one you commented out but I think this the correct one
  // and the same as the one I coppied over from PostTop below
  // useEffect(() => {
  //   if ( currentUser &&  currentUser?.groups.length > 0 &&
  //   (currentUser?.groups[0]?.name === "Admincreative" || currentUser?.groups[0]?.name === "Crew")
  //   ) {
  //     // now check where the post is His own post or NOT
  //     if (Number(profile_id) !== Number(currentUser?.profile_id)) {
  //       setShowActionMenu(false);
  //     }
  //   } else {
  //     if (
  //       currentUser &&
  //       currentUser?.groups.length > 0 &&
  //       currentUser?.groups[0]?.name === "Cast"
  //     ) {
  //       // Never show the menu
  //       setShowActionMenu(false);
  //     }
  //   }
  // }, [profile_id, currentUser]);

  // one you had in place
  // useEffect(() => {
  //   if (
  //     currentUser &&
  //     currentUser?.groups.length > 0
  //   ) {
  //     const userRole = currentUser.groups[0].name;
  //     if (userRole === "Admincreative") {
  //       console.log(currentUser?.profile_id === profile_id)
  //       if (Number(profile_id) === Number(currentUser?.profile_id)) {
  //         setShowActionMenu(true);
  //       }
  //     } else if (userRole === "Crew") {
  //       if (Number(profile_id) === Number(currentUser?.profile_id)) {
  //         setShowActionMenu(true);
  //       }
  //     } else if (userRole === "Cast") {
  //       setShowActionMenu(false);
  //     }
  //   }
  // }, [profile_id, currentUser]);

  useEffect(() => {
      if (
        currentUser &&
        currentUser?.groups.length > 0 &&
        (currentUser?.groups[0]?.name === "Admincreative" ||
          currentUser?.groups[0]?.name === "Crew")
      ) {
        // now check where the post is His own post or NOT
        if (Number(profile_id) !== Number(currentUser?.profile_id)) {
          setShowActionMenu(false);
        }
      } else {
        if (
          currentUser &&
          currentUser?.groups.length > 0 &&
          currentUser?.groups[0]?.name === "Cast"
        ) {
          // Never show the menu
          setShowActionMenu(false);
        }
      }
    }, [profile_id, currentUser]);
    
  const handleGoToScene = () => {
    /* Function to go to the post's Scene page 
           and it's Department Category
        *  Sets the Contexts SceneId, Number, Category 
           ans Dept to be read in App.js*/
    setSceneId(scene);
    setNumber(number);
    setDept(departments);
    setCategory(category);
    history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && project && episodeTitle
                ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
                : ""
            }`
          ); 
  };

  const handleEdit = () => {
    history.push(
      `/${localStorage.getItem("projectSlug")}/posts/${id}/edit${epi && project && episodeTitle && number
        ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}&sceneID=${number}`
        : ""
      }`
    );
  };

  const handleDelete = async () => {
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        await axiosRes.delete(`/posts/${id}/`);
        history.goBack();
        toast.success(`Post Deleted`);
      } else {
        await axiosInstance.delete(
          `${localStorage.getItem("projectSlug")}/posts/${id}/`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );
        history.goBack();
        toast.success(`Post Deleted Successfully!`);
      }
    } catch (err) { }
  };

  const handleStar = async () => {
    /* Function to Star a Post 
         * Creates an archives instance for the Post as the 
           Archives App in Shot Caller DRF is used for the Star feature */
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        const { data } = await axiosRes.post("/archives/", { post: id });
        setPosts((prevPosts) => ({
          // Update the post in the posts state with the archives_id
          ...prevPosts,
          results: prevPosts.results.map((post) => {
            return post.id === id ? { ...post, archive_id: data.id } : post;
          }),
        }));
      } else {
        const { data } = await axiosInstance.post(
          `${localStorage.getItem("projectSlug")}/archives/`,
          { post: id },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );
        setPosts((prevPosts) => ({
          // Update the post in the posts state with the archives_id
          ...prevPosts,
          results: prevPosts.results.map((post) => {
            return post.id === id ? { ...post, archive_id: data.id } : post;
          }),
        }));
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleUnStar = async () => {
    /* Function to unStar a Post 
         * Deletes an archives instance for the Post as the 
           Archives App in Shot Caller DRF is used for the Star feature */
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        await axiosRes.delete(`/archives/${archive_id}/`);
        setPosts((prevPosts) => ({
          // Delete the archives_id for the post in the posts state
          ...prevPosts,
          results: prevPosts.results.map((post) => {
            return post.id === id ? { ...post, archive_id: null } : post;
          }),
        }));
      } else {
        await axiosInstance.delete(
          `${localStorage.getItem("projectSlug")}/archives/${archive_id}/`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );
        setPosts((prevPosts) => ({
          // Delete the archives_id for the post in the posts state
          ...prevPosts,
          results: prevPosts.results.map((post) => {
            return post.id === id ? { ...post, archive_id: null } : post;
          }),
        }));
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleLike = async () => {
    /* Function to create a likes instance for a Post */
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        const { data } = await axiosRes.post("/likes/", { post: id });
        setPosts((prevPosts) => ({
          // Update the post in the posts state with the likes_id
          ...prevPosts,
          results: prevPosts.results.map((post) => {
            return post.id === id
              ? { ...post, likes_count: post.likes_count + 1, like_id: data.id }
              : post;
          }),
        }));
      } else {
        const { data } = await axiosInstance.post(
          `${localStorage.getItem("projectSlug")}/likes/`,
          { post: id },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );
        setPosts((prevPosts) => ({
          // Update the post in the posts state with the likes_id
          ...prevPosts,
          results: prevPosts.results.map((post) => {
            return post.id === id
              ? { ...post, likes_count: post.likes_count + 1, like_id: data.id }
              : post;
          }),
        }));
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleUnlike = async () => {
    /* Function to delete a likes instance for a Post */
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        await axiosRes.delete(`/likes/${like_id}/`);
        setPosts((prevPosts) => ({
          // Delete the likes_id for the post in the posts state
          ...prevPosts,
          results: prevPosts.results.map((post) => {
            return post.id === id
              ? { ...post, likes_count: post.likes_count - 1, like_id: null }
              : post;
          }),
        }));
      } else {
        await axiosInstance.delete(
          `${localStorage.getItem("projectSlug")}/likes/${like_id}/`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );
        setPosts((prevPosts) => ({
          // Delete the likes_id for the post in the posts state
          ...prevPosts,
          results: prevPosts.results.map((post) => {
            return post.id === id
              ? { ...post, likes_count: post.likes_count - 1, like_id: null }
              : post;
          }),
        }));
      }
    } catch (err) {
      console.log(err);
    }
  };

  // Utility function to detect file type from URL
  const detectFileType = async (url) => {
    try {
      const response = await fetch(url, { method: "HEAD" });

      if (!response.ok) {
        console.error("Error fetching file:", response.statusText);
        return "unknown";
      }

      const contentType = response.headers.get("Content-Type");

      if (contentType && contentType.startsWith("image/")) {
        return "image";
      }

      if (
        contentType &&
        (contentType === "application/pdf" ||
          contentType.includes("document") ||
          contentType === "application/msword" ||
          contentType ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document")
      ) {
        return "document";
      }

      return "unknown";
    } catch (error) {
      console.error("Error detecting file type:", error);
      return "unknown";
    }
  };

  // Component to render file based on type
  const FileRenderer = ({
    fileUrl,
    altText,
    imageClassName,
    iframeClassName,
  }) => {
    const [fileType, setFileType] = useState("unknown");
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
      const checkFileType = async () => {
        setIsLoading(true);
        const type = await detectFileType(fileUrl);
        setFileType(type);
        setIsLoading(false);
      };

      checkFileType();
    }, [fileUrl]);

    if (isLoading) {
      return <div>Loading...</div>;
    }

    if (fileType === "image") {
      return (
        <div className="px-2 px-md-4 mb-3">
          <Card.Img src={fileUrl} alt={altText} className={imageClassName} />
        </div>
      );
    } else {
      return (
        <figure>
          <iframe
            title={altText}
            alt={altText}
            className={iframeClassName}
            src={fileUrl}
          />
        </figure>
      );
    }
  };

  const handleClickFull1 = () => {
    setImage(image1); 
    history.push(`/${localStorage.getItem("projectSlug")}/fullshot`);
  };

  const handleClickFull2 = () => {
    setImage(image2); 
    history.push(`/${localStorage.getItem("projectSlug")}/fullshot`);
  };

  const handleClickFull3 = () => {
    setImage(image3); 
    history.push(`/${localStorage.getItem("projectSlug")}/fullshot`);
  };

  const handleClickFull4 = () => {
    setImage(image4); 
    history.push(`/${localStorage.getItem("projectSlug")}/fullshot`);
  };

  const handleClickFull5 = () => {
    setImage(image5); 
    history.push(`/${localStorage.getItem("projectSlug")}/fullshot`);  
  };

  return (
    <div className="px-3">
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} ml-1 mb-2`}
        onClick={() => history.goBack()}
      >
        Back
      </Button>
      <h5 style={{ textTransform: 'uppercase'}} 
      className={`mt-1 mb-1 py-1 ${styles.SubTitle } text-center`}>
       POST - {departments} {category}
      </h5>
      <Card className={`py-0 mt-3 mb-0`}>
      <Card.Body className={`py-0 px-0 ${styles.PostTop2}`}>
      <Row className={`d-flex align-items-center my-0 py-0 py-sm-1 `}>
      <Col xs={12} md={3} className="my-0" >
          {/* small */}
          <div className='d-none d-md-block'>
          <Row >
          <Col xs={3} className="pl-3 pr-0 d-flex align-items-center">
          <Link
            to={`/${localStorage.getItem(
              "projectSlug"
            )}/profiles/${profile_id}`}
          >
            <Avatar src={profile_image} height={45} />
          </Link>
          </Col>
          <Col xs={9} className="pl-2 pr-0" >
          <div className={`${styles.Content4} pl-2 ml-2`}>
          <p>{name}</p>
          <p style={{ textTransform: "capitalize" }} 
          className={`${styles.Posit}`}>{position}
          </p>
          </div>
          </Col>
          </Row>   
          </div>     
          {/* mobile */}
          <div className='d-md-none '>
          <Row className='pb-0 mb-0'>
          <Col className="d-flex align-items-center" xs={2}>
              <Link
                to={`/${localStorage.getItem(
                  "projectSlug"
                )}/profiles/${profile_id}`}
              >
                <Avatar src={profile_image} height={45} />
              </Link>
          </Col>
          <Col xs={8} className={`${styles.NamePos} text-center`} >
          <p >
            {name}
          </p> 
          <p style={{ textTransform: "capitalize" }} 
          className={`${styles.Posit}`}>{position}
          </p>    
          <Row className="d-flex align-items-center">
          <Col xs={6} className="text-center">
          {/* icons theirs mobile with block removed */}
          <div className="px-0 py-0 ml-4 d-flex align-items-center justify-content-center">
            {archive_id ? (
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>UnStar</Tooltip>}
              >
                <span onClick={handleUnStar}>
                  <i className={`fas fa-star ${styles.Star}`} />
                </span>
              </OverlayTrigger>
            ) : currentUser ? (
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Star</Tooltip>}
              >
                <span onClick={handleStar}>
                  <i className={`far fa-star ${styles.Star}`} />
                </span>
              </OverlayTrigger>
            ) : (
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Log in please</Tooltip>}
              >
                <i className={`far fa-star ${styles.Star}`} />
              </OverlayTrigger>
            )}
            {is_owner ? (
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip>You can't like your own post!</Tooltip>
                }
              >
                <i className={`far fa-heart ${styles.Heart}`} />
              </OverlayTrigger>
            ) : like_id ? (
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Unlike</Tooltip>}
              >
                <span onClick={handleUnlike}>
                  <i className={`fas fa-heart ${styles.Heart}`} />
                </span>
              </OverlayTrigger>
            ) : currentUser ? (
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Like</Tooltip>}
              >
                <span onClick={handleLike}>
                  <i className={`far fa-heart ${styles.Heart}`} />
                </span>
              </OverlayTrigger>
            ) : (
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Log in please</Tooltip>}
              >
                <i className={`far fa-heart ${styles.Heart}`} />
              </OverlayTrigger>
            )}
            <span className={`${styles.SmallI}`}>{likes_count}</span>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Comments</Tooltip>}
                >
                  <Link
                    to={`/${localStorage.getItem(
                      "projectSlug"
                    )}/posts/${id}${
                      epi && project && episodeTitle && number
                        ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}&sceneID=${number}`
                        : ""
                    }`}
                  >
                    <i
                      className={`far fa-comments ${styles.Comment}`}
                    />
                  </Link>
                </OverlayTrigger>
                <span className={`${styles.SmallI}`}>{comments_count}</span>
          </div>
          </Col>
          <Col xs={6} className="text-center pr-2">
          <p className={ `ml-3 pt-1 pb-0 mb-0 ${styles.Date}`}> {updated_at}</p>
          </Col>
          </Row>     
          </Col>
          <Col xs={2} className={`${styles.Icon} d-flex align-items-center`}>
            {showActionMenu && (
              <PostDropdown
                handleEdit={handleEdit}
                handleDelete={handleDelete}
              />
            )}
          </Col>
          </Row> 
          <Row className="mx-2">
          {/* scene dept categ */}
          <Col xs={12} md={6} className={`${styles.ContentOpened} px-1 mb-2 mb-md-1 mt-1`} >
          <OverlayTrigger
              className="px-0 mx-0"
                    placement="top"
                    overlay={<Tooltip>Go to Scene</Tooltip>}>
          <div className={`${styles.GoToScene}`} onClick={() => handleGoToScene() }>
          <Row className={` py-md-2 my-0 px-3 d-flex align-items-center text-center`}>
          <Col xs={12} 
            className={`px-3 text-center`} >
            <Row className={`d-flex align-items-center text-center`}>
              <Col xs={1} className={`${styles.Go} my-0 py-0 px-0`} >
            <i className="navicon fas fa-play py-0 my-0"></i>
            </Col>
              <Col className='px-0 mx-0' xs={3}>
              {number && <p style={{ fontWeight: '700' }}>
              {episode_number && (
                  <span style={{ fontWeight: "700" }} className={`pr-1`}>
                    E {episode_number}{" "} 
                  </span>
                )} {" "}  Scene {number} </p>}
              </Col>
              <Col className='px-0 mx-0' xs={4}>
                {departments && <p style={{ textTransform: 'capitalize'}}>
                  {departments}</p>}
              </Col>
              <Col className='px-0 mx-0' xs={4}>
                {category && <p style={{ textTransform: 'capitalize'}}>
                      {category} </p>}  
              </Col>
            </Row >
            {/* <Row className={`my-0 py-0`}>
            <Col xs={1} className={`${styles.Go} my-0 py-0`} >
            <i className="navicon fas fa-play py-0 my-0"></i>
            </Col>
            </Row> */}
            </Col>
          </Row>
          </div>
          </OverlayTrigger>
          </Col>
          </Row>
          </div> 
      </Col> 
      {/* scene dept categ */}
      <Col xs={12} md={6} className={`${styles.ContentOpened2} d-none d-md-block px-3 mb-2 mb-md-1 mt-1`} >
      <OverlayTrigger
          className="px-0 mx-0"
                placement="top"
                overlay={<Tooltip>Go to Scene</Tooltip>}>
      <div className={`${styles.GoToScene}`} onClick={() => handleGoToScene() }>
      <Row className={` py-md-2 my-0 px-3 d-flex align-items-center text-center`}>
      <Col xs={12} 
        className={`px-3 text-center`} >
        <Row className={`d-flex align-items-center text-center`}>
          <Col xs={1} className={`${styles.Go} my-0 py-0 px-0`} >
          <i className="navicon fas fa-play py-0 my-0"></i>
          </Col>
          <Col className='px-0 mx-0' xs={3}>
          {number && <p style={{ fontWeight: '700' }}>
          {episode_number && (
              <span style={{ fontWeight: "700" }} className={`pr-1`}>
                E {episode_number}{" "} 
              </span>
            )} {" "}  Scene {number} </p>}
          </Col>
          <Col className='px-0 mx-0' xs={4}>
            {departments && <p style={{ textTransform: 'capitalize'}}>
              {departments}</p>}
          </Col>
          <Col className='px-0 mx-0' xs={4}>
            {category && <p style={{ textTransform: 'capitalize'}}>
                  {category} </p>}  
          </Col>
        </Row >
        {/* <Row className={`my-0 py-0`}>
        <Col xs={1} className={`${styles.Go} my-0 py-0`} >
        <i className="navicon fas fa-play py-0 my-0"></i>
        </Col>
        </Row> */}
        </Col>
      </Row>
      </div>
      </OverlayTrigger>
      </Col>
      {/* edit and date icons small */}
      <Col xs={12} md={3} className="my-0 " >
      <div className='d-none d-md-block'>
      <Row >
      <Col className="pl-0 pr-0" sm={9} >
      <p className={ `text-center pr-2 ${styles.Date}`}>{updated_at}
      </p>
      {/* icons  */}
      <div className="px-0 py-0 d-flex align-items-center justify-content-center">
        {archive_id ? (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>UnStar</Tooltip>}
          >
            <span onClick={handleUnStar}>
              <i className={`fas fa-star ${styles.Star}`} />
            </span>
          </OverlayTrigger>
        ) : currentUser ? (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>Star</Tooltip>}
          >
            <span onClick={handleStar}>
              <i className={`far fa-star ${styles.Star}`} />
            </span>
          </OverlayTrigger>
        ) : (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>Log in please</Tooltip>}
          >
            <i className={`far fa-star ${styles.Star}`} />
          </OverlayTrigger>
        )}
        {is_owner ? (
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip>You can't like your own post!</Tooltip>
            }
          >
            <i className={`far fa-heart ${styles.Heart}`} />
          </OverlayTrigger>
        ) : like_id ? (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>Unlike</Tooltip>}
          >
            <span onClick={handleUnlike}>
              <i className={`fas fa-heart ${styles.Heart}`} />
            </span>
          </OverlayTrigger>
        ) : currentUser ? (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>Like</Tooltip>}
          >
            <span onClick={handleLike}>
              <i className={`far fa-heart ${styles.Heart}`} />
            </span>
          </OverlayTrigger>
        ) : (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>Log in please</Tooltip>}
          >
            <i className={`far fa-heart ${styles.Heart}`} />
          </OverlayTrigger>
        )}
        <span className={`${styles.SmallI}`}>{likes_count}</span>
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip>Comments</Tooltip>}
            >
              <Link
                to={`/${localStorage.getItem(
                  "projectSlug"
                )}/posts/${id}${
                  epi && project && episodeTitle && number
                    ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}&sceneID=${number}`
                    : ""
                }`}
              >
                <i
                  className={`far fa-comments ${styles.Comment}`}
                />
              </Link>
            </OverlayTrigger>
            <span className={`${styles.SmallI}`}>{comments_count}</span>
      </div>
      </Col>
      <Col
        sm={3}
        className="d-flex align-items-center px-0 float-right"
      >
        {showActionMenu && (
          <PostDropdown
            handleEdit={handleEdit}
            handleDelete={handleDelete}
          />
        )}
      </Col>
      </Row>   
      </div>     
      </Col>
      </Row>
      </Card.Body>
      {/* title */}
      <Card.Body className='pt-2 px-md-5'>
          {title && <h5 style={{ fontStyle: 'italic' }}
          className="text-center">{title}</h5>}
          <hr className={`mt-2 mb-0`} />
          {content && <Card.Text>{content}</Card.Text>}
      </Card.Body>
      <hr />
      {image1 || image2 || image3 || image4 || image5 ? (
      <h5 className={`text-center py-0 mx-5 my-3 ${styles.SubTitle }`}
      >IMAGES/FILES</h5>
      ) : ("") }
        <Row className="px-0">
          {/* image 1/2 */}
          <Col xs={12} md={6} className="px-3">
            {image1 && (
              <Card className='mx-3' >
              <Card.Body className={`text-center px-md-3 pb-0 `}>
              <FileRenderer
                fileUrl={image1}
                altText="image1"
                allow="fullscreen"
                imageClassName={styles.ImagesIndex}
                iframeClassName={styles.iframe}
              />
              </Card.Body>
              <Card.Body className="my-0 py-0">
                <p className={`${styles.BoldScene} text-center my-0 py-0`}>
                  IMAGE/FILE 1</p>
                <p className={`text-center mb-0 pb-0 float-right ${styles.FullsizeText }`}
                  onClick={() => handleClickFull1() }>FULLSIZE</p> 
              </Card.Body>
              </Card>
            )}
          </Col>
          <Col xs={12} md={6} className="px-3 mt-3 mt-md-0">
            {image2 && (
              <Card className='mx-3' >
              <Card.Body className={`text-center px-md-3 pb-0`}>
              <FileRenderer
                fileUrl={image2}
                altText="image3"
                imageClassName={styles.ImagesIndex}
                iframeClassName={styles.iframe}
              />
              </Card.Body>
              <Card.Body className="my-0 py-0">
                <p className={`${styles.BoldScene} text-center my-0 py-0`}>
                  IMAGE/FILE 2</p>
                <p className={`text-center mb-0 pb-0 float-right ${styles.FullsizeText }`}
                  onClick={() => handleClickFull2() }>FULLSIZE</p> 
              </Card.Body>
              </Card>
            )}
          </Col>
        </Row>
        {/* break */}
        {image3 ? (
        <Row>
        <Col xs={12}>
        <hr className={`${styles.BreakIm} mt-3 mb-3 d-none d-md-block`}/>
        </Col>
        </Row>
        ) : ("") }
        {/* image 3/4 */}
        <Row className="px-0">
          <Col xs={12} md={6} className="px-3 mt-3 mt-md-0">
            {image3 && (
              <Card className='mx-3' >
              <Card.Body className={`text-center px-md-3 pb-0`}>
              <FileRenderer
                fileUrl={image3}
                altText="image3"
                allow="fullscreen"
                imageClassName={styles.ImagesIndex}
                iframeClassName={styles.iframe}
              />
              </Card.Body>
              <Card.Body className="my-0 py-0">
                <p className={`${styles.BoldScene} text-center my-0 py-0`}>
                  IMAGE/FILE 3</p>
                <p className={`text-center mb-0 pb-0 float-right ${styles.FullsizeText }`}
                  onClick={() => handleClickFull3() }>FULLSIZE</p> 
              </Card.Body>
              </Card>
            )}
          </Col>
          <Col xs={12} md={6} className="px-3 mt-3 mt-md-0">
            {image4 && (
              <Card className='mx-3' >
              <Card.Body className={`text-center px-md-3 pb-0`}>
              <FileRenderer
                fileUrl={image4}
                altText="image4"
                allow="fullscreen"
                imageClassName={styles.ImagesIndex}
                iframeClassName={styles.iframe}
              />
              </Card.Body>
              <Card.Body className="my-0 py-0">
                <p className={`${styles.BoldScene} text-center my-0 py-0`}>
                  IMAGE/FILE 4</p>
                <p className={`text-center mb-0 pb-0 float-right ${styles.FullsizeText }`}
                  onClick={() => handleClickFull4() }>FULLSIZE</p> 
              </Card.Body>
              </Card>
            )}
          </Col>
        </Row>
        {/* break */}
        {image5 ? (
        <Row>
        <Col xs={12}>
        <hr className={`${styles.BreakIm} mt-3 mb-3 d-none d-md-block`}/>
        </Col>
        </Row>
        ) : ("") }
        {/* image 5 */}
        <Row className="mb-2 px-0">
          <Col className='d-none d-md-block' md={3} ></Col>
          <Col className={`text-center px-3 mx-0 mb-5 mt-3 mt-md-0`} xs={12} md={6}>
            {image5 && (
             <Card className='mx-3' >
              <Card.Body className={`text-center px-md-3 pb-0`}>
              <FileRenderer
                fileUrl={image5}
                altText="image5"
                allow="fullscreen"
                imageClassName={styles.ImagesIndex}
                iframeClassName={styles.iframe}
              />
              </Card.Body>
              <Card.Body className="my-0 py-0">
                <p className={`${styles.BoldScene} text-center my-0 py-0`}>
                  IMAGE/FILE 1</p>
                <p className={`text-center mb-0 pb-0 float-right ${styles.FullsizeText }`}
                  onClick={() => handleClickFull5() }>FULLSIZE</p> 
              </Card.Body>
              </Card>
            )}
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default Post;
